module.exports = __webpack_public_path__ + "img/bindChat_a.efc628ab.png";